import { showFailToast } from 'vant';
import CompCard from './proItem.vue';
import { getproListSjw } from '@/api/index.js';
export default {
  name: 'pro-list',
  props: ["type", "show"],
  components: {
    CompCard
  },
  data() {
    return {
      proList: [],
      loading: false,
      finished: false,
      is_next: true,
      page: 1
    };
  },
  watch: {
    show(newVal) {
      if (!newVal) {
        this.loading = false;
      }
    }
  },
  mounted() {
    this.getProList();
  },
  methods: {
    goToInfo(item, index) {
      this.$emit('goToProInfo', item, index, 'feed流');
    },
    onLoad() {
      setTimeout(() => {
        if (!this.is_next) return;
        this.getProList();
      }, 1000);
    },
    getProList() {
      let option = Object.assign({
        page_size: 10,
        page: this.page,
        status: this.type
      });
      getproListSjw(option).then(res => {
        this.loading = false;
        if (res.status == 0) {
          if (res.data.list && res.data.list.length > 0) {
            const list = res.data.list.map(item => {
              item.type = "pro";
              item.card_info = {
                img_url: item.img_url,
                name: item.name,
                progress: this.type == 2 ? "0%" : item.progress,
                status_code: this.type == 2 ? 1 : '',
                bullish_count: item.bullish_count,
                backer_money: item.backer_money,
                backer_count: item.backer_count
              };
              return item;
            });
            this.proList.push(...list);
            this.is_next = res.data.is_next;
            if (this.is_next) {
              this.page += 1;
            } else {
              this.finished = true;
            }
          } else {
            this.finished = true;
          }
        } else {
          this.finished = true;
          showFailToast(res.message);
        }
      });
    }
  }
};